var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0ZM14 9.7998C13.2268 9.7998 12.5996 10.3576 12.5996 11.0449V19.7559C12.5998 20.443 13.2269 21 14 21C14.7731 21 15.4002 20.443 15.4004 19.7559V11.0449C15.4004 10.3576 14.7732 9.7998 14 9.7998ZM14 5.59961C13.2268 5.59961 12.5996 6.2268 12.5996 7C12.5996 7.7732 13.2268 8.40039 14 8.40039C14.7732 8.40039 15.4004 7.7732 15.4004 7C15.4004 6.2268 14.7732 5.59961 14 5.59961Z",
    fill: "#6D57BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipInfoIcon);
export default __webpack_public_path__ + "static/media/tooltipInfoIcon.60a9f71cdbeac0f849cb089dc373987f.svg";
export { ForwardRef as ReactComponent };